import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotariesComponent } from './notaries.component';
import { CreateFormComponent } from '../_shared/create-form/create-form.component';

const routes: Routes = [
  {
    path    : 'notaries',
    children: [
      {path: '', component: NotariesComponent},
      {path: 'create', component: CreateFormComponent, data: {editorType: 'create', componentName: 'notary'}},
      {path: ':id/edit', component: CreateFormComponent, data: {editorType: 'edit', componentName: 'notary'}},
    ],
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class NotariesRoutingModule {
}
